import React from "react";

const Card = ({value, height, onClick, selected, index}) => {

    const cardHeight = height ? height : 160;
    const cardOverlap = -cardHeight/2.5;

    return (
        <img
            src={require('./card_images/' + value + '.png')}
            onClick={() => onClick(index)}
            alt="img"
            draggable={false}
            style={{
                backgroundColor: selected ? "black" : "white",
                padding: "4px",
                marginRight: cardOverlap + "px",
                marginTop: selected ? "0px" : "50px",
                marginBottom: selected ? "50px" : "0px",
                boxShadow: "-1px 1px 25px -7px rgba(0,0,0,0.23)",
                borderRadius: "8px",
                height: cardHeight,
            }}
        />
    );
};

export default Card;